
import React, { useEffect, useState, useRef } from "react";
import Navbar from "../../Navbar/Navbar";
import axios from "axios";
import baseURL from "../../config";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaEdit, FaUserCircle, FaSyncAlt, FaSearch } from "react-icons/fa";
import ContractModal from "./ContractModal.jsx";
import UserModal from "./UserModal/UserModal.jsx";
import { EditNote } from "@mui/icons-material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CircularProgress from '@mui/material/CircularProgress';


import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  TextField,
  TablePagination,
  InputAdornment
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import AssignmentIcon from "@mui/icons-material/Assignment";
import TouchAppIcon from '@mui/icons-material/TouchApp';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const ContractTable = () => {
  // State variables
  const [contracts, setContracts] = useState({ contracts: [] });
  const { id: crewingAgentId } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [statusHistory, setStatusHistory] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false);
  const [crewingAgent, setCrewingAgent] = useState([]);
  const [updatedbankDetails, setUpdatedBankDetails] = useState({});
  const navigate = useNavigate();
  const [openBankModal, setOpenBankModal] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    BankHolderName: '',
    bankName: '',
    accountNumber: '',
    ifscCode: '',
    branchName: '',
    bankAdress: '',
  });


  const [isLoading, setIsLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false); // Separate loading state for search
  const [openModal, setOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDocuments, setModalDocuments] = useState([]);
  const [selectedApprovals, setSelectedApprovals] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState(null);

  // Pagination State
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalContracts, setTotalContracts] = useState(0);

  // // Fetch all contract details
  // const fetchContracts = async () => {
  //   const token = localStorage.getItem("token");
  //   try {
  //     const endpoint = crewingAgentId
  //       ? `/api/getContractDetailsByAgent/${crewingAgentId}`
  //       : "/api/getContractDetails";
  //     const response = await axios.get(`${baseURL}${endpoint}`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     setContracts(response.data || []);
  //     setTotalContracts(response.data.totalContracts)
  //   } catch (error) {
  //     console.error("Error fetching contract details:", error.message);
  //   }
  // };

  // Refs for maintaining focus and debounce
  const searchInputRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  // Fetch all contract details with search and pagination
  const fetchContracts = async (withSearch = false) => {
    const token = localStorage.getItem("token");
    try {
      if (withSearch) {
        setSearchLoading(true); // Only show search loading for search operations
      } else {
        setIsLoading(true); // Show full loading for initial/pagination loads
      }

      let endpoint;
      if (crewingAgentId) {
        // Always start with page and limit
        endpoint = `/api/getContractDetailsByAgent/${crewingAgentId}?page=${page + 1}&limit=${rowsPerPage}`;

        // Then add search if present
        if (searchTerm.trim()) {
          endpoint += `&search=${encodeURIComponent(searchTerm.trim())}`;
        }
      } else {
        endpoint = `/api/getAllContractData?page=${page + 1}&limit=${rowsPerPage}`;
        if (searchTerm.trim()) {
          endpoint += `&search=${encodeURIComponent(searchTerm.trim())}`;
        }
      }

      const response = await axios.get(`${baseURL}${endpoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data) {
        setContracts(response.data || 0);
        setTotalContracts(response.data.totalContracts || 0);
      }
    } catch (error) {
      console.error("Error fetching contract details:", error?.response?.data?.message);
      setError(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
      setSearchLoading(false);
    }
  };


  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const displayNames = {
    pipolicydocument: "P&I Certificate",
    maritimelabourconvention: "Maritime Labour Convention",
    fsdocument: "Financial Security Document",
    dmlcp1: "DMLC Part 1",
    dmlc2: "DMLC Part 2",
  };


  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  // Improved search handling with proper debouncing
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Clear any existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Set a new timeout
    searchTimeoutRef.current = setTimeout(() => {
      setPage(0); // Reset to first page when search term changes
      fetchContracts(true); // true indicates this is a search operation
    }, 500);
  };


  // Handle search input key press (Enter)
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      setPage(0);
      fetchContracts(true);
    }
  };


  // Handle manual search button click
  const handleSearchClick = () => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    setPage(0);
    fetchContracts(true);
  };


  // Clear search with focus maintained
  const handleClearSearch = () => {
    setSearchTerm("");
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    setPage(0);
    // Use setTimeout to ensure the state update completes before fetching
    setTimeout(() => {
      fetchContracts(true);
      // Maintain focus after clearing
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 0);
  };


  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);


  // Bank Details
  const BankDetails = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${baseURL}/api/CrewinngAccount/CrewingAgentADetailsccount/${crewingAgentId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    setUpdatedBankDetails(response.data.data)
  }


  const handleOpenHistory = async (contractId) => {
    try {
      const response = await axios.get(
        `${baseURL}/api/contract-statusById/${contractId}`
      );


      if (response.data.success) {
        setStatusHistory(response.data.data.statusHistory || []);
        setShowModal(true);
      } else {
        console.error("Error fetching contract status:", response.data.message);
      }
    } catch (error) {
      console.error(
        "Failed to fetch contract status:",
        error.response?.data?.message || error.message
      );
    }
  };


  const handleOpenModal = (title, docs) => {
    setModalTitle(title);
    setModalDocuments(docs);
    setOpenModal(true);
  };


  useEffect(() => {
    fetchContracts();

    if (crewingAgentId) {
      fetchCrewingAgent();
      BankDetails();
    }
  }, [crewingAgentId, page, rowsPerPage]); // Re-fetch when pagination changes


  //fetch CrewingAgents details
  const fetchCrewingAgent = async () => {
    if (!crewingAgentId) {
      console.error("Crewing Agent ID is undefined, skipping API call.");
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${baseURL}/api/getCrewingAgentsDetailsById/${crewingAgentId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      setCrewingAgent(response.data);
    } catch (error) {
      console.error("Error fetching crewing Agents details:", error.message);
    }
  };

  const handleApprovalChangeadmin = (contractId, value) => {
    setSelectedApprovals((prev) => ({
      ...prev,
      [contractId]: value,
    }));
  };


  const handleOpenUpdateForm = (contract) => {
    navigate(`/ContractUpdate/${contract._id}`);
  };


  const handleSubmit = async (contractId, crewingAgentId) => {
    const approvalStatus = selectedApprovals[contractId];


    if (!approvalStatus) {
      toast.error("Please select a status before submitting.");
      return;
    }


    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(`${baseURL}/api/contract-status`, {
        contractId,
        crewingAgentId,
        crewingAgentStatus: null,
        adminStatus: approvalStatus,
        approvedBy: "Admin",
        updatedAt: new Date().toISOString(),
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });


      if (response.status === 201) {
        toast.success("Status updated successfully!");
        fetchContracts(); // Refresh data instead of window.location.reload()
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status.");
    }
  };


  const handleEdit = (contract) => {
    navigate("/EditContractTable", {
      state: {
        contract: contract,
        crewingAgentId: crewingAgentId,
      },
    });
  };


  const handleApprovalChange = async (contractId, isApproved) => {
    try {
      const token = localStorage.getItem("token");


      const response = await axios.post(
        `${baseURL}/api/approvecontract/${contractId}`,
        { isApproved },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (response.status === 200) {
        toast.success("Contract approval status updated");
        fetchContracts(); // Refresh data instead of manipulating state directly
      }
    } catch (error) {
      console.error("Error updating approval status:", error.response?.data || error.message);
      toast.error("Failed to update approval status");
    }
  };


  const setShowBankModal = () => {
    setOpenBankModal(true);
  };


  const handleCloseBankModal = () => {
    setOpenBankModal(false);
    setBankDetails({
      BankHolderName: '',
      bankName: '',
      accountNumber: '',
      ifscCode: '',
      branchName: '',
      bankAdress: '',
    });
  };


  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prevData) => ({ ...prevData, [name]: value }));
  };


  const handleBankSubmit = async () => {
    const payload = {
      BankHolderName: bankDetails.BankHolderName,
      crewingAgentId: crewingAgentId,
      accountNumber: bankDetails.accountNumber,
      bankName: bankDetails.bankName,
      ifscCode: bankDetails.ifscCode,
      branchName: bankDetails.branchName,
      bankAdress: bankDetails.bankAdress,
    }

    const token = localStorage.getItem("token");
    try {
      await axios.post(`${baseURL}/api/CrewinngAccount/CrewingAgentAccount`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Bank details saved successfully");
      handleCloseBankModal();
      BankDetails(); // Refresh bank details
    } catch (err) {
      console.error("Error saving bank details:", err);
      toast.error("Failed to save bank details");
    }
  }
  const handleSignInSignOffClick = () => {
    navigate(`/SignInSignOff/${crewingAgentId}`, {
      state: { openFormI: true }, // ✅ pass state
    });
  };

  return (
    <>
      <div>
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '16rem',
            }}
          >
            <CircularProgress color="primary" size={60} thickness={5} />
          </Box>
        ) : (
          <div>
            <Navbar />
            {error && (
              <Box p={4} textAlign="center" bgcolor="#fdecea" color="#b71c1c">
                <Typography color="error" variant="h6">
                  {error}
                </Typography>
              </Box>
            )}
            <Box sx={{ marginTop: 2, padding: 2 }}>
              {/* Flex container for title and button */}
              <Box display="flex" justifyContent="center" alignItems="center" mb={2} sx={{ width: "100%" }}>
                {crewingAgentId && (
                  <Typography variant="h5" sx={{ display: "flex", alignItems: "center", textAlign: "center", color: "#FF6F00" }}>
                    {crewingAgent.agentName}
                  </Typography>
                )}
              </Box>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>


                {/* Left Side: Enhanced Search Bar */}
                <Box display="flex" gap={2}>
                  <TextField
                    inputRef={searchInputRef}
                    label="Search by Vessel, Crew, Indos No."
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    onKeyPress={handleKeyPress}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {searchLoading ? (
                            <CircularProgress size={20} />
                          ) : (
                            <IconButton onClick={handleSearchClick} size="small">
                              <FaSearch />
                            </IconButton>
                          )}
                          {searchTerm && (
                            <IconButton onClick={handleClearSearch} size="small">
                              ✕
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>


                {/* Centered Title with Icon */}
                <Typography variant="h5" display="flex" alignItems="center">
                  <AssignmentIcon sx={{ marginRight: 1, color: "#C30B12" }} />
                  Assigned Contract Details
                </Typography>


                {/* Right Side: Buttons + Total Contracts + Bank Details */}
                <Box display="flex" alignItems="center" gap={2}>


                  {/* Show SignIn/SignOff and Add Contract Buttons only when crewingAgentId is NOT present */}
                  {!crewingAgentId && (
                    <Box display="flex" gap={2}>
                      <Button component={Link} to="/SignInSignOff" state={{ openFormI: true }} variant="contained" sx={{ backgroundColor: "#C30B12" }}>
                        SignIn/SignOff
                      </Button>


                      <Button component={Link} to="/ContractForm" variant="contained" sx={{ backgroundColor: "#C30B12" }}>
                        Add Contract
                      </Button>
                      <Button
                        component={Link}
                        to="/ContractForVesselOwner"
                        variant="contained"
                        sx={{ backgroundColor: "#C30B12" }}
                      >
                        Vessel Owner Contract
                      </Button>
                    </Box>
                  )}

                  {crewingAgentId && (
                    <Box display="flex" gap={2}>
                      <Button
                        variant="contained"
                        sx={{ backgroundColor: "#C30B12" }}
                        onClick={handleSignInSignOffClick}
                      >
                        SignIn / SignOff
                      </Button>
                    </Box>
                  )}

                  {/* Total Contracts Box */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, padding: "6px 12px", bgcolor: "#fff3cd", borderRadius: "8px" }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#856404" }}>
                      Total Contract:
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#d39e00" }}>
                      {totalContracts}
                    </Typography>
                  </Box>


                  {/* Bank Details Button (only if crewingAgentId exists) */}
                  {crewingAgentId && (
                    <Button variant="contained" onClick={() => setShowBankModal(true)} sx={{ backgroundColor: "#C30B12" }}>
                      Bank Details
                    </Button>
                  )}


                  {/* User Icon (only if crewingAgentId exists) */}
                  {crewingAgentId && (
                    <IconButton onClick={() => setShowUserModal(true)}>
                      <FaUserCircle size={40} />
                    </IconButton>
                  )}
                </Box>
              </Box>


              <TableContainer component={Paper} sx={{ overflowX: "auto", width: "100%" }}>
                <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                  <TableHead sx={{ backgroundColor: "#C30B12", height: "30px", overflow: "hidden" }}>
                    <TableRow>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "80px" }}>Sr. No.</TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", }}>Vessel Owner</TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "270px" }}>Crew</TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "175px" }}>Crewing Agent</TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", }}>Status</TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "70px" }}> <TouchAppIcon /></TableCell>
                      {!crewingAgentId && (
                        <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "130px" }}>Approval</TableCell>
                      )}
                      {!crewingAgentId && (
                        <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "0.8rem", width: "180px" }}>Status</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {contracts?.contracts?.length > 0 ? (
                      contracts.contracts.map((contract, index) => (
                        <TableRow key={`${contract._id}-${index}`}>{console.log("contract", contract)}
                          <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                          <TableCell>
                            <Box sx={{ fontSize: "0.85rem", display: "flex", flexDirection: "column", gap: "4px" }}>
                              {!crewingAgentId && (<Typography>
                                <strong>Company:</strong> {contract.vesselOwner?.company_shortname || "N/A"}
                              </Typography>)}


                              <Typography>
                                <strong>Vessel:</strong> {contract.ShipDetails?.vesselname || "N/A"}
                              </Typography>


                              {!crewingAgentId && contract?.createdAt && (
                                <>
                                  <Typography>
                                    <strong>Contract Created At:</strong>{" "}
                                    {new Date(contract.createdAt).toLocaleDateString("en-GB", {
                                      day: "numeric",
                                      month: "short",
                                      year: "numeric",
                                    })}{" "}
                                    {new Date(contract.createdAt).toLocaleTimeString("en-US", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true,
                                    })}
                                  </Typography>

                                </>
                              )}
                              {!crewingAgentId && (
                                <Typography
                                  sx={{ marginTop: 1, fontSize: "1rem", }}
                                >
                                  <strong>Contract Created By:</strong>  {contract?.creatorIdWithName?.[0]?.name || "N/A"}
                                </Typography>
                              )}


                              <Button
                                variant="contained"

                                sx={{ alignSelf: "flex-start", mt: 1, backgroundColor: "#D4AF37" }}
                                onClick={() =>
                                  handleOpenModal(
                                    "Vessel Documents",
                                    [
                                      "pipolicydocument",
                                      "maritimelabourconvention",
                                      "fsdocument",
                                      "dmlcp1",
                                      "dmlc2",
                                    ].map((doc) => ({
                                      name: doc.replace(/([A-Z])/g, " $1"),
                                      filePath: contract?.ShipDetails?.[doc]?.filePath || null,
                                    }))
                                  )
                                }
                              >
                                Vessel Files
                              </Button>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Name:</strong>{" "}
                              {contract.crewdetails?.name || "N/A"}
                            </Typography>
                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Indos No.:</strong>{" "}
                              {contract.crewdetails?.indosno || "N/A"}
                            </Typography>
                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Email:</strong>{" "}
                              {contract.crewdetails?.email || "N/A"}
                            </Typography>{console.log("contract", contract)}
                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Rank:</strong>{" "}
                              {contract.crewdetails?.rankname || "N/A"}
                            </Typography >
                            {/* contract Duration */}
                            {contract?.contractDuration && <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Contract Duration:</strong>{" "}
                              {contract?.contractDuration || "N/A"}
                            </Typography >}
                            {/* Button to Open Modal with Crew Documents */}
                            <Button
                              variant="contained"
                              sx={{ backgroundColor: "#E53935" }}
                              onClick={() =>
                                handleOpenModal(
                                  "Crew Documents",
                                  [
                                    { key: "crewDocument", label: "Crew Document" },
                                    { key: "passportDocument", label: "Passport" },
                                    { key: "cdcDocument", label: "CDC" },
                                    { key: "stcwDocument", label: "STCW" },
                                    { key: "stsdsdDocument", label: "STSDSD" },
                                    { key: "pscrbDocument", label: "PSCRB" },
                                    { key: "watchkeepingDocument", label: "Watchkeeping" },
                                    { key: "CopDocument", label: "COP" },
                                    { key: "yellowfeverDocument", label: "Yellow Fever" },
                                    { key: "CovidVaccineDocument", label: "COVID Vaccine" },
                                    { key: "iloDocument", label: "ILO" },
                                    { key: "sidDocument", label: "SID" },
                                    { key: "h2sDocument", label: "H2S" },
                                    { key: "CrewPhotoDocument", label: "Crew Photo" },
                                    { key: "cookcocDocument", label: "Cook COC" },
                                    { key: "officercocDocument", label: "Officer COC" },
                                    { key: "gocDocument", label: "GOC" },
                                    { key: "gmdssDocument", label: "GMDSS" },
                                    { key: "huetDocument", label: "HUET" },
                                    { key: "highvoltageDocument", label: "High Voltage" },
                                    { key: "brmDocument", label: "BRM" },
                                    { key: "degreeDiplomaDocument", label: "Degree/Diploma" },
                                    { key: "bosietDocument", label: "BOSIET" },
                                    { key: "signContratDocument", label: "Signed Contract" },
                                    // { key: "visaDocument", label: "Visa" },
                                    // { key: "ticketDocument", label: "Ticket" },

                                    { key: "AFF", label: "Advanced Fire Fighting (AFF)" },
                                    { key: "MFA", label: "Medical First Aid (MFA)" },
                                    { key: "PSSR", label: "Personal Safety and Social Responsibility (PSSR)" },
                                    { key: "SSO", label: "Ship Security Officer (SSO)" },
                                    { key: "BTM", label: "Bridge Team Management (BTM)" },
                                    { key: "ECDIS", label: "ECDIS" },
                                    { key: "contract", label: "Contract" },
                                    { key: "BankDocument", label: "Bank Details" },
                                  ].map((doc) => ({
                                    name: doc.label,
                                    filePath: contract?.crewdetails?.[doc.key]?.filePath || null,
                                  }))
                                    .filter((doc) => doc.filePath)
                                )
                              }
                            >
                              Crew Files
                            </Button>


                          </TableCell>
                          <TableCell>
                            <Box display="flex" flexDirection="column" alignItems="start">
                              {/* Crewing Agent Name */}
                              <Typography
                                sx={{
                                  mb: 1,
                                  wordBreak: "break-word",
                                  whiteSpace: "normal",
                                  // fontSize: "0.8rem",
                                  maxWidth: "175px"
                                }}
                              >
                                {contract?.crewingAgent?.agentName || "N/A"}
                              </Typography>


                              {/* Documents Button */}
                              <Button
                                variant="contained"
                                sx={{ backgroundColor: "#C94E17" }}
                                // Only render the button if there are uploaded documents
                                style={{
                                  display: [
                                    "BSM", "RPSL", "NOK", "DrugAlcoholPolicy",
                                    "CheckList", "DeclarationForm", "TravelTicket",
                                    "Visa", "LOG", "SignedContract"
                                  ].some(type => contract[type]?.filePath) ? 'block' : 'none'
                                }}
                                onClick={() => {
                                  // Collect only uploaded documents
                                  const uploadedDocuments = [
                                    { type: "BSM", color: "primary" },
                                    { type: "RPSL", color: "secondary" },
                                    { type: "NOK", color: "success" },
                                    { type: "DrugAlcoholPolicy", color: "warning" },
                                    { type: "CheckList", color: "info" },
                                    { type: "DeclarationForm", color: "error" },
                                    { type: "TravelTicket", color: "success" },
                                    { type: "Visa", color: "warning" },
                                    { type: "LOG", color: "info" },
                                    { type: "SignedContract", color: "error" }
                                  ].filter(file => contract[file.type]?.filePath);


                                  // Open a modal or dialog to show these documents
                                  handleOpenModal(
                                    "Crewing Agent Documents",
                                    uploadedDocuments.map(file => ({
                                      name: file.type,
                                      filePath: contract[file.type].filePath.startsWith("http")
                                        ? contract[file.type].filePath
                                        : `${baseURL}/${contract[file.type].filePath.replace(/\\/g, "/")}`
                                    }))
                                  );
                                }}
                              >
                                Documents
                              </Button>
                            </Box>
                          </TableCell>


                          <TableCell>
                            <Typography sx={{ fontSize: "0.85rem" }}>


                              <strong>Admin Status:</strong>{" "}
                              {contract.contractStatus?.latestStatus?.adminStatus ||
                                "N/A"}
                            </Typography>


                            <Typography sx={{ fontSize: "0.85rem" }}>
                              <strong>Crewing Agent Status:</strong>{" "}
                              {contract.contractStatus?.latestStatus?.crewingAgentStatus || "N/A"}
                            </Typography>
                            {/* Show Animated Text if Crewing Agent Status is "Pending" */}
                            {contract.isApproved && (!contract.contractStatus?.latestStatus?.crewingAgentStatus ||
                              contract.contractStatus.latestStatus.crewingAgentStatus !== "Approve") && (
                                <Typography
                                  sx={{
                                    fontSize: "1rem",
                                    color: "#FF4500",
                                    fontWeight: "bold",
                                    // marginLeft: "6rem",
                                    display: "flex",
                                    alignItems: "center",
                                    animation: "pulse 1.5s infinite"
                                  }}
                                >
                                  Agent Please approve contract
                                  <ArrowForwardIcon sx={{ fontSize: "2rem", color: "#FF6347" }} />
                                </Typography>
                              )}




                            {contract.contractStatus?.latestStatus?.crewingAgentStatus !== "Pending" &&
                              contract.contractStatus?.latestStatus?.remark && (
                                <>
                                  <Typography sx={{ fontSize: "0.85rem" }}>
                                    <strong>Remark:</strong>{" "}
                                    {contract.contractStatus.latestStatus.remark}
                                  </Typography>
                                  <Typography sx={{ fontSize: "0.85rem" }}>
                                    <strong>Created At:</strong>{" "}
                                    {contract.contractStatus.latestStatus.updatedAt
                                      ? new Date(
                                        contract.contractStatus.latestStatus.updatedAt
                                      ).toLocaleString()
                                      : "N/A"}
                                  </Typography>
                                </>
                              )}




                            {contract?.contractStatus?.statusHistory?.length > 0 && (
                              <Button
                                sx={{ backgroundColor: '#E49B0F', color: '#fff', '&:hover': { backgroundColor: '#1d4ed8' } }}
                                onClick={() => handleOpenHistory(contract._id)}>
                                View History
                              </Button>
                            )}


                            {contract.contractStatus?.formI?.filePath ? (
                              <Typography variant="body2" color="primary" sx={{ mt: 1, fontSize: "0.85rem" }}>
                                <a
                                  href={
                                    contract.contractStatus.formI.filePath.startsWith("http")
                                      ? contract.contractStatus.formI.filePath  // S3 URL (already a valid URL)
                                      : `${baseURL}/${contract.contractStatus.formI.filePath.replace(/\\/g, "/")}` // Local path
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View Form I
                                </a>
                                {!crewingAgentId && <Typography sx={{ color: "red", fontWeight: "bold" }}>
                                  Form I uploaded. Proceed to Sign On/Sign Off for further processing. </Typography>}


                              </Typography>
                            ) : contract.contractStatus?.latestStatus?.crewingAgentStatus === "Approve" ? (
                              <Typography
                                variant="body2"
                                color="error"
                                sx={{
                                  fontSize: "1rem",
                                  color: "#FF4500",
                                  fontWeight: "bold",
                                  // marginLeft: "8rem",
                                  display: "flex",
                                  alignItems: "center",
                                  animation: "pulse 1.5s infinite"
                                }}
                              >
                                Please add Form I
                                <ArrowForwardIcon sx={{ fontSize: "2rem", color: "#FF6347" }} />
                              </Typography>
                            ) : null}
                            {/* Add Animation in CSS */}
                            <style>
                              {`
                           @keyframes pulse {
                          0% { transform: scale(1); opacity: 1; }
                          50% { transform: scale(1.1); opacity: 0.8; }
                         100% { transform: scale(1); opacity: 1; }
                                }
                              `}
                            </style>
                          </TableCell>
                          <TableCell>
                            {!crewingAgentId && (<Tooltip title="Update contract" arrow>
                              <IconButton
                                color="primary"
                                onClick={() => handleOpenUpdateForm(contract)}


                              >
                                <FaEdit />
                              </IconButton>
                            </Tooltip>)}
                            <Tooltip title="Update Status" arrow>
                              <IconButton color="primary" onClick={() => handleEdit(contract)}>
                                <EditNote />
                              </IconButton>
                            </Tooltip>
                          </TableCell>


                          {!crewingAgentId && (
                            <TableCell>
                              {contract.isApproved ? (
                                <Typography
                                  sx={{ color: "green", fontWeight: "bold", fontSize: "0.85rem" }}
                                >
                                  Contract Approved By Admin
                                </Typography>
                              ) : (
                                <Button
                                  variant="contained"
                                  sx={{ backgroundColor: "#B8860B" }}

                                  onClick={() => handleApprovalChange(contract._id, true)}
                                >
                                  Approve
                                </Button>
                              )}


                              {/* <Typography
                                sx={{ marginTop: 1, fontSize: "0.85rem", color: "text.secondary" }}
                              >
                                Created By: {contract?.creatorIdWithName?.[0]?.name || "N/A"}
                              </Typography> */}
                            </TableCell>
                          )}


                          {!crewingAgentId && contract?.contractStatus?.formI?.filePath && (
                            <TableCell>
                              {contract?.contractStatus?.latestStatus?.adminStatus === "final approvel" ? (
                                <span style={{ fontWeight: "bold", color: "green" }}>Final Approved</span>
                              ) : (
                                <>
                                  <select
                                    value={selectedApprovals[contract._id] || ""}
                                    onChange={(e) =>
                                      handleApprovalChangeadmin(contract._id, e.target.value)
                                    }
                                  >
                                    <option value="">Select Status</option>
                                    <option value="Reject">Reject</option>
                                    <option value="Correction Required">Correction Required</option>
                                    <option value="final approvel">Final Approval</option>
                                  </select>


                                  <Button
                                    sx={{
                                      backgroundColor: '#2563eb',
                                      color: '#fff',
                                      '&:hover': { backgroundColor: '#1d4ed8' }
                                    }}
                                    onClick={() => handleSubmit(contract._id, contract.crewingAgent._id)}
                                  >
                                    Submit
                                  </Button>


                                </>
                              )}
                            </TableCell>
                          )}


                          {/* Rest of your table rows... (unchanged) */}
                          {/* ...Table Cell content remains the same... */}

                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          {searchTerm ? (
                            <Typography>No contracts found matching "{searchTerm}".</Typography>
                          ) : (
                            <Typography>No contracts available.</Typography>
                          )}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination Component */}
              {contracts?.contracts?.length > 0 && (
                <TablePagination
                  component="div"
                  count={totalContracts}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />
              )}
            </Box>


            {/* Modals remain unchanged */}
            {/* ContractModal, UserModal, etc. */}


            {showUserModal && (
              <UserModal
                onClose={() => setShowUserModal(false)}
                crewingAgent={crewingAgent}
                updatedbankDetails={updatedbankDetails}
              />
            )}
            {showModal && (
              <ContractModal
                onClose={() => setShowModal(false)}
                statusHistory={statusHistory ?? []}
              />
            )}


            {/* Documents Modal */}
            <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth>
              <DialogTitle>{modalTitle}</DialogTitle>
              <DialogContent>
                {modalDocuments.length > 0 ? (
                  modalDocuments.map((doc, index) => (


                    <Paper
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: 2,
                        mb: 2,
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                        <Typography>{displayNames[doc.name] || doc.name}</Typography>
                      </Box>
                      {doc.filePath ? (
                        <Button
                          variant="contained"
                          href={doc.filePath.startsWith("http") ? doc.filePath : `${baseURL}/${doc.filePath.replace(/\\/g, "/")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download
                        </Button>
                      ) : (
                        <Box display="flex" alignItems="center">
                          <ReportProblemIcon sx={{ color: "orange", mr: 1 }} />
                          <Typography color="error">No File Available</Typography>
                        </Box>
                      )}
                    </Paper>
                  ))
                ) : (
                  <Typography textAlign="center" color="textSecondary">
                    No documents available
                  </Typography>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenModal(false)}>Close</Button>
              </DialogActions>
            </Dialog>


            {/* Bank Details Modal */}
            <Dialog open={openBankModal} onClose={handleCloseBankModal} maxWidth="sm">
              <DialogTitle>Enter Bank Details</DialogTitle>
              <DialogContent>
                <TextField label="Bank Holder Name" fullWidth margin="dense" name="BankHolderName" value={bankDetails.BankHolderName} onChange={handleBankInputChange} />
                <TextField label="Bank Name" fullWidth margin="dense" name="bankName" value={bankDetails.bankName} onChange={handleBankInputChange} />
                <TextField label="Account Number" fullWidth margin="dense" name="accountNumber" value={bankDetails.accountNumber} onChange={handleBankInputChange} />
                <TextField label="IFSC" fullWidth margin="dense" name="ifscCode" value={bankDetails.ifscCode} onChange={handleBankInputChange} />
                <TextField label="Branch" fullWidth margin="dense" name="branchName" value={bankDetails.branch} onChange={handleBankInputChange} />
                <TextField label="Bank Address" fullWidth margin="dense" name="bankAdress" value={bankDetails.bankAdress} onChange={handleBankInputChange} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseBankModal}>Cancel</Button>
                <Button onClick={handleBankSubmit} variant="contained" color="primary">Submit</Button>
              </DialogActions>
            </Dialog>


            <ToastContainer />
          </div>
        )}
      </div>
    </>
  );
};


export default ContractTable;

